export default __webpack_public_path__ + "media/communication.de6500c3791670d50c57f01e2caf01d5.svg";